import ApplyToOriginal from './ApplyToOriginal';
import {
  originalInvoicedataSel,
  originalInvoiceDebitSel,
  originalInvoiceCreditSel
} from 'src/store/modules/invoices';
import actions from 'src/store/modules/invoices/actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const mapStateToprops = (state: any) => ({
  selectedOriginalInvoices: originalInvoicedataSel(state),
  totalDebit: originalInvoiceDebitSel(state),
  totalCredit: originalInvoiceCreditSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  getOriginalInvoices: () => dispatch(actions.getOriginalInvoices()),
  setSelectedInvoices: (invoices: any) =>
    dispatch(actions.setSelectedInvoices(invoices))
});

export default connect(
  mapStateToprops,
  mapDispatchToProps
)(withRouter(ApplyToOriginal));

// interface IApplyToOriginalProps {
//     getOriginalInvoices(): void;
//   }
